var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.399902,
    width: 45,
    height: 45,
    rx: 4,
    fill: "url(#paint0_linear_2633_7663)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.159 20.3577C31.2961 20.2487 31.5 20.3507 31.5 20.5229V27.7124C31.5 28.644 30.7441 29.3999 29.8125 29.3999H15.1875C14.2559 29.3999 13.5 28.644 13.5 27.7124V20.5265C13.5 20.3507 13.7004 20.2522 13.841 20.3612C14.6285 20.9729 15.6727 21.7499 19.2586 24.355C20.0004 24.8964 21.252 26.0354 22.5 26.0284C23.7551 26.039 25.0312 24.8753 25.7449 24.355C29.3309 21.7499 30.3715 20.9694 31.159 20.3577ZM22.5 24.8999C23.3156 24.914 24.4898 23.8733 25.0805 23.4444C29.7457 20.0589 30.1008 19.7636 31.1766 18.9198C31.3805 18.7616 31.5 18.5155 31.5 18.2554V17.5874C31.5 16.6558 30.7441 15.8999 29.8125 15.8999H15.1875C14.2559 15.8999 13.5 16.6558 13.5 17.5874V18.2554C13.5 18.5155 13.6195 18.7581 13.8234 18.9198C14.8992 19.7601 15.2543 20.0589 19.9195 23.4444C20.5102 23.8733 21.6844 24.914 22.5 24.8999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7663",
    x1: 39.2108,
    y1: 60.2994,
    x2: -15.0779,
    y2: 39.2056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.23da126f9624d5be09b86338b96bf9f2.svg";
export { ForwardRef as ReactComponent };